import { render, staticRenderFns } from "./resend-code-link.vue?vue&type=template&id=12871bf5&scoped=true"
import script from "./resend-code-link.vue?vue&type=script&lang=ts"
export * from "./resend-code-link.vue?vue&type=script&lang=ts"
import style0 from "./resend-code-link.vue?vue&type=style&index=0&id=12871bf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12871bf5",
  null
  
)

export default component.exports